import { Component } from '@angular/core';

@Component({
  selector: 'contacts-panel',
  templateUrl: './contacts-panel.component.html'
})
export class ContactsPanelComponent {
  constructor() {}
}
